import { hotRank } from "@/mocks/gossip";
import { trendMap } from "./Hero";

export default function HeatRank() {
  const topThree = hotRank.slice(0, 3);
  const rest = hotRank.slice(3);

  return (
    <section id="hot" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col justify-between gap-3 sm:flex-row sm:items-end md:mb-10">
          <div>
            <p className="text-xs font-medium uppercase tracking-widest text-accent-600">Hot Right Now</p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
              今日瓜田热度榜
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              按讨论量与互动热度实时排序，前排就是当下最值得吃的那口瓜。
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-500/15 px-3 py-1.5 text-xs font-medium text-secondary-700">
            <i className="ri-refresh-line" aria-hidden="true"></i>
            每 60 分钟更新一次
          </span>
        </div>

        <div className="grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
          {/* 前三名大卡 */}
          <div className="grid gap-4 sm:grid-cols-3 lg:grid-cols-1 xl:grid-cols-3">
            {topThree.map((item) => {
              const trend = trendMap[item.trend];
              return (
                <article
                  key={item.rank}
                  className="relative flex flex-col gap-3 overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-5"
                >
                  <div className="flex items-center justify-between">
                    <span className="font-heading text-4xl font-bold text-primary-500/90">
                      0{item.rank}
                    </span>
                    <span className={`flex h-8 w-8 items-center justify-center rounded-full ${trend.cls}`}>
                      <i className={`${trend.icon} text-sm`} aria-hidden="true"></i>
                    </span>
                  </div>
                  <p className="text-xs font-medium text-accent-600">{item.category}</p>
                  <h3 className="text-base font-bold leading-snug text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                  <div className="mt-auto flex items-center gap-1.5 text-xs font-medium text-primary-600">
                    <i className="ri-fire-fill" aria-hidden="true"></i>
                    热度指数 {item.heat.toFixed(1)}
                  </div>
                </article>
              );
            })}
          </div>

          {/* 4-8名列表 */}
          <div className="flex flex-col gap-3">
            {rest.map((item) => {
              const trend = trendMap[item.trend];
              return (
                <article
                  key={item.rank}
                  className="group flex items-start gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:bg-background-100/70"
                >
                  <span className="mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-background-200/80 text-sm font-bold text-foreground-700">
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="text-xs text-accent-600">{item.category}</span>
                      <span className={`flex h-6 w-6 items-center justify-center rounded-full ${trend.cls}`}>
                        <i className={`${trend.icon} text-xs`} aria-hidden="true"></i>
                      </span>
                    </div>
                    <h3 className="mt-1 text-sm font-semibold leading-snug text-foreground-900 group-hover:text-primary-700">
                      {item.title}
                    </h3>
                    <div className="mt-1.5 flex items-center gap-1.5 text-xs text-primary-600">
                      <i className="ri-fire-fill" aria-hidden="true"></i>
                      热度 {item.heat.toFixed(1)}
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}